import {DEVELOPMENT, STAGING, LOCAL} from "@irati/utils/constants/environment"
import environment from "@irati/utils/env"
import {classBindThis} from "@irati/utils/functions"

type LightLogger = Pick<Console, "log" | "warn" | "error">

export class BrazeLogger implements LightLogger {
  batch: any[][] = []

  enabled = false

  timer: null | number = null

  constructor(env?: string, private timeout = 2, private collapsed = true) {
    this.enabled = [STAGING, DEVELOPMENT, LOCAL].includes(env ?? "nope")
    classBindThis(this)
  }

  error(...message: any): void {
    this.batchLog(message)
  }

  log(...message: any): void {
    this.batchLog(message)
  }

  warn(...message: any): void {
    this.batchLog(["WARNING", ...message])
  }

  private batchLog(message: any[]) {
    if (!this.enabled) {
      return
    }

    this.batch.push(message)

    if (this.timer === null) {
      this.timer = setTimeout(() => {
        this.print()
      }, this.timeout * 1000)
    }
  }

  private print() {
    if (this.collapsed) {
      console.groupCollapsed("Braze")
    } else {
      console.group("Braze")
    }
    this.batch.forEach((m) => console.log(...m))
    this.batch = []
    this.timer = null
    console.groupEnd()
  }
}

const brazeLogger = new BrazeLogger(environment.ENVIRONMENT_NAME)
export default brazeLogger
